'use strict';

var FaresOptimizerCompetitorLadderDataService = function FaresOptimizerCompetitorLadderDataService(restangular, faresOptimizerDataTransformerService) {
  var competitorFareLadderEndPoint = restangular.one('external').one('faresoptimizer').one('competitorfareladder');
  function getCompetitorLadder(filter) {
    return competitorFareLadderEndPoint.one('latest').get({
      filter: filter,
      pageLimit: -1
    });
  }
  function getCompetitorLadderData(filter) {
    return getCompetitorLadder(filter).then(faresOptimizerDataTransformerService.transformCompetitorLadder);
  }
  return {
    getCompetitorLadderData: getCompetitorLadderData
  };
};
FaresOptimizerCompetitorLadderDataService.$inject = ['Restangular', 'FaresOptimizerDataTransformerService'];
module.exports = FaresOptimizerCompetitorLadderDataService;